import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import {
  SlideOutVideo,
  SlideOutActions,
  SlideOutSubtitle,
  SlideOutTodoList
} from "../../components/SlideOut";
import SlideOutTitle from "../../components/SlideOut/SlideOutTitle";
import { useTranslation } from "react-i18next";
import {
  learnLearningPathListView,
  libraryAllCoursesHome
} from "../../routes/LearningCenterRoutes";

// TODO: Change to get correct button for the learner view welcome slide out and implement functionality
function getSlideOutButtons(userPermissions, t) {
  const todoButtons = [];
  if (userPermissions.allowLearningPathAssignments) {
    todoButtons.push({
      text: t("welcomeSlideOut.welcomeSlideOutButtons.learningPathButton"),
      variant: "outlined",
      path: learnLearningPathListView
    });
  }
  if (userPermissions.allowLibraryAccess) {
    todoButtons.push({
      text: t("welcomeSlideOut.welcomeSlideOutButtons.CTAButton"),
      variant: "outlined",
      path: libraryAllCoursesHome
    });
  }
  return todoButtons;
}

export default function LearnerView(props) {
  const { currentUser } = props;
  const { t } = useTranslation();
  function firstSignIn() {
    return props.currentUser.signInCount <= 1;
  }

  function signedInPreviously() {
    return !firstSignIn();
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      pt={{ xs: 23, sm: 27 }}
      px={{ xs: 4, sm: 7 }}
      m={2}
      height="100%"
    >
      <Box pb={6.25} display="flex" flexDirection="column">
        {currentUser && (
          <SlideOutTitle currentUserFirstName={currentUser.firstName} />
        )}
        {props.subtitle && (
          <Box pb={6.25}>
            <SlideOutSubtitle subtitle={props.subtitle} />
          </Box>
        )}
      </Box>
      {signedInPreviously() && props.todoList && (
        <SlideOutTodoList
          todoList={props.todoList}
          fetchTodos={props.fetchTodos}
          handleSlideOutClose={props.handleSlideOutClose}
        />
      )}
      {firstSignIn() && props.videoUrl && (
        <SlideOutVideo link={props.videoUrl} />
      )}
      {currentUser && (
        <SlideOutActions
          actions={getSlideOutButtons(currentUser.permissions, t)}
          currentUser={currentUser}
          handleSlideOutClose={props.handleSlideOutClose}
        />
      )}
    </Box>
  );
}

LearnerView.propTypes = {
  title: PropTypes.string,
  todoList: PropTypes.arrayOf(
    PropTypes.shape({
      todoType: PropTypes.oneOf([
        "Assignment",
        "My Courses",
        "My Policies",
        "Message"
      ]),
      type: PropTypes.oneOf(["toDo"]),
      title: PropTypes.string,
      number: PropTypes.string,
      imageSrc: PropTypes.any,
      overdue: PropTypes.bool,
      dueDate: PropTypes.any,
      assignmentStarted: PropTypes.bool,
      description: PropTypes.string
    })
  ),
  todoListLoading: PropTypes.bool,
  subtitle: PropTypes.string,
  videoUrl: PropTypes.string
};
